export interface IIbanList {
  id: number;
  bic: string;
  bankCode: string;
  name: string;
}

const iBANList: IIbanList[] = [
  {
    id: 1,
    bic: 'ATYNKZKA',
    bankCode: '949',
    name: 'АО "Altyn Bank" (ДБ China Citic Bank Corporation Limited)',
  },
  {
    id: 2,
    bic: 'BKCHKZKA',
    bankCode: '913',
    name: 'АО ДБ "БАНК КИТАЯ В КАЗАХСТАНЕ"',
  },
  { id: 3, bic: 'BRKEKZKA', bankCode: '914', name: 'АО "Bereke Bank"' },
  { id: 4, bic: 'CASPKZKA', bankCode: '722', name: 'АО "KASPI BANK"' },
  {
    id: 5,
    bic: 'CEDUKZKA',
    bankCode: '766',
    name: 'АО "Центральный Депозитарий Ценных Бумаг"',
  },
  { id: 6, bic: 'CITIKZKA', bankCode: '832', name: 'АО "Ситибанк Казахстан"' },
  {
    id: 7,
    bic: 'DVKAKZKA',
    bankCode: '907',
    name: 'АО "Банк Развития Казахстана"',
  },
  {
    id: 8,
    bic: 'EABRKZKA',
    bankCode: '700',
    name: 'ЕВРАЗИЙСКИЙ БАНК РАЗВИТИЯ',
  },
  { id: 9, bic: 'EURIKZKA', bankCode: '948', name: 'АО "Евразийский Банк"' },
  {
    id: 10,
    bic: 'GCVPKZ2A',
    bankCode: '009',
    name: 'НАО Государственная корпорация "Правительство для граждан"',
  },
  {
    id: 11,
    bic: 'HCSKKZKA',
    bankCode: '972',
    name: 'АО "Жилищный строительный сберегательный банк "Отбасы банк"',
  },
  {
    id: 12,
    bic: 'HLALKZKZ',
    bankCode: '246',
    name: 'АО "Исламский Банк "Al Hilal"',
  },
  {
    id: 13,
    bic: 'HSBKKZKX',
    bankCode: '601',
    name: 'АО "Народный Банк Казахстана"',
  },
  {
    id: 14,
    bic: 'ICBKKZKX',
    bankCode: '930',
    name: 'АО "Торгово-промышленный Банк Китая в г. Алматы"',
  },
  {
    id: 15,
    bic: 'INEARUMM',
    bankCode: '550',
    name: 'г.Москва Межгосударственный Банк',
  },
  { id: 16, bic: 'INLMKZKA', bankCode: '886', name: 'АО "Home Credit Bank"' },
  { id: 17, bic: 'IRTYKZKA', bankCode: '965', name: 'АО "ForteBank"' },
  { id: 18, bic: 'KCJBKZKX', bankCode: '856', name: 'АО "Банк ЦентрКредит"' },
  {
    id: 19,
    bic: 'KICEKZKX',
    bankCode: '927',
    name: 'АО "Казахстанская фондовая биржа"',
  },
  { id: 20, bic: 'KINCKZKA', bankCode: '821', name: 'АО "Банк "Bank RBK"' },
  {
    id: 21,
    bic: 'KKMFKZ2A',
    bankCode: '070',
    name: 'РГУ "Комитет казначейства Министерства финансов РК"',
  },
  { id: 22, bic: 'KPSTKZKA', bankCode: '563', name: 'АО "КАЗПОЧТА"' },
  {
    id: 23,
    bic: 'KSNVKZKA',
    bankCode: '551',
    name: 'АО "Банк Фридом Финанс Казахстан"',
  },
  {
    id: 24,
    bic: 'KZIBKZKA',
    bankCode: '885',
    name: 'АО "ДБ "КАЗАХСТАН-ЗИРААТ ИНТЕРНЕШНЛ БАНК"',
  },
  {
    id: 25,
    bic: 'NBRKKZKX',
    bankCode: '125',
    name: 'РГУ Национальный Банк Республики Казахстан',
  },
  { id: 26, bic: 'NURSKZKX', bankCode: '849', name: 'АО "Нурбанк"' },
  {
    id: 27,
    bic: 'SHBKKZKA',
    bankCode: '435',
    name: 'АО "Шинхан Банк Казахстан"',
  },
  {
    id: 28,
    bic: 'TSESKZKA',
    bankCode: '998',
    name: 'АО "Alatau City Bank"',
  },
  {
    id: 29,
    bic: 'VTBAKZKZ',
    bankCode: '432',
    name: 'ДО АО Банк ВТБ (Казахстан)',
  },
  {
    id: 30,
    bic: 'ZAJSKZ22',
    bankCode: '896',
    name: 'АО "Исламский банк "Заман-Банк"',
  },
];

export default iBANList;
